import { render } from "./CopyActivityModal.vue?vue&type=template&id=789130a9&scoped=true"
import script from "./CopyActivityModal.vue?vue&type=script&lang=js"
export * from "./CopyActivityModal.vue?vue&type=script&lang=js"

import "./CopyActivityModal.vue?vue&type=style&index=0&id=789130a9&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789130a9"]])

export default __exports__